import React from 'react'
import createReactClass from 'create-react-class'
import _ from 'lodash'
import i18n from 'live/services/i18n'
import FormGroup from 'live/components/forms/ui/form-group'
import serviceLocator from 'live/services/service-locator'
import { FormEnabledContext } from 'live/context/form-enabled'

const ExportForm = createReactClass({
    getInitialState: () => ({}),
    toggleEnabled() {
        const { object, applyObj } = this.props
        const config = object.config

        config.store.enabled = !config.store.enabled
        applyObj({ config: config })
    },

    onChangeInput({ target }) {
        const { name, value } = target
        const { object, applyObj } = this.props
        const config = object.config

        config.store[name] = value
        applyObj({ config: config })
    },

    componentDidMount() {
        serviceLocator.getService('liverig-wells-shared-components').then(wellsService => {
            const Rigs = wellsService.Rigs

            this.setState({ Rigs })
        })
        serviceLocator.getService('liverig-curves-shared-components').then(curvesService => {
            const TimestampModes = curvesService.TimestampModes
            const Curves = curvesService.Curves

            this.setState({ TimestampModes, Curves })
        })
    },

    onChangeTimestampMode({ target }) {
        const { object, applyObj } = this.props
        const config = object.config

        config.store.timestamp_mode = target.value
        applyObj({ config: config })
    },

    onChangeCurves(values) {
        const { object, applyObj } = this.props
        const config = object.config
        const curves = []

        _.map(values, value => {
            curves.push((value && value.curve) || '')
        })

        config.store.curves = curves
        applyObj({ config: config })
    },

    onChangeWell(wells) {
        const { object, applyObj } = this.props
        const config = object.config

        config.store.wells = wells
        applyObj({ config: config })
    },

    makeLink(qualifier, path) {
        const host = location.origin

        return host + '/services/plugin-petrobras' + (qualifier ? '/' + qualifier : '') + '/' + path
    },

    render() {
        const { object } = this.props
        const { config } = object

        const { TimestampModes, Curves, Rigs } = this.state
        const { readonly } = this.context

        return (
            <div className="export-form">
                <div className="form-area">
                    <h3>{i18n('Export-noun')}</h3>
                    <div className="form-group clearfix">
                        <label className="radio regular">
                            <input
                                type="radio"
                                name="sender-enabled"
                                checked={config.store.enabled}
                                disabled={readonly && !config.store.enabled}
                                onChange={this.toggleEnabled}
                            />
                            {i18n('Enabled')}
                        </label>
                        <label className="radio regular">
                            <input
                                type="radio"
                                name="sender-enabled"
                                checked={!config.store.enabled}
                                disabled={readonly && config.store.enabled}
                                onChange={this.toggleEnabled}
                            />
                            {i18n('Disabled')}
                        </label>
                    </div>

                    <h3>{i18n('Connection')}</h3>
                    <div className="url">
                        <span>
                            <label>URL ({i18n('export')})</label>
                            {this.makeLink(object.qualifier, 'samter')}
                        </span>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup
                                type="number"
                                label={
                                    <span>
                                        {i18n('Interval between events')} ({i18n('ms')}) <abbr title="required">*</abbr>
                                    </span>
                                }
                                name="events_interval"
                                value={parseInt(config.store.events_interval)}
                                onChange={this.onChangeInput}
                            />
                        </div>
                    </div>

                    <h3>{i18n('Event timestamp')}</h3>
                    {TimestampModes ? (
                        <TimestampModes config={config.store} onChange={this.onChangeTimestampMode} hideLabel={true} />
                    ) : null}
                </div>

                <div className="tables">
                    {Curves ? <Curves onChange={this.onChangeCurves} config={config.store} /> : null}
                    {Rigs ? <Rigs onChange={this.onChangeWell} config={config.store} allowDisableRig={true} /> : null}
                </div>
            </div>
        )
    }
})

ExportForm.contextType = FormEnabledContext
module.exports = ExportForm
